import _ from "lodash";

export const convertParamsToStateParams = function (params) {
  if (params.distributors) {
    params.distributors = _.split(params.distributors, ",");
  }
  return params;
};
